import level1 from "src/assets/images/expeditions/level1.png";
import level2 from "src/assets/images/expeditions/level2.png";
import level3 from "src/assets/images/expeditions/level3.png";
import level4 from "src/assets/images/expeditions/level4.png";
import level5 from "src/assets/images/expeditions/level5.png";
import level6 from "src/assets/images/expeditions/level6.png";
import { environment } from "./constance";

const vaultConfigTestnet = {
  rookie: {
    id: "rookie",
    name: "Rookie",
    title: "Ruins of Alzatecia",
    description: `The Ruins of Alzatecia is located far to the west of the Trava Kingdom, in the middle of the Nymeria desert. Once a prosperous city, all that is left now are some stone columns and stone statues, portraying long forgotten kings - or gods.\n
      It is still unknown why Alzatecia was destroyed, but historians have agreed that the city’s position between the rocky pillars made it invulnerable to invasions. Upon further inspection of skeletons, traces of a deadly bacteria were found, and historians concluded that the city was most probably wiped by a plague.\n
      Nevertheless, adventurers still venture to these ruins, trying to find lost artifacts to collect or to sell on the black market. But, the land is desolated and infested with desert monsters - huge sandworms, giant vultures and deadly spiders - and the duty of keeping the place safe for travel falls on the noble Trava Knights.
    `,
    contractAddress: "0xCF8B29E9762a8bE82d8Bc9822Ce3096D4F03388c",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 1,
    img: level1,
    color: "#6F3902",
    status: "available",
  },
  professional: {
    id: "professional",
    name: "Professional",
    title: "Peaks of Orange Mountain",
    description: `Situated on the Northern border of the Kingdom, Orange Mountain range got its name from the spectacular sight on the Summer Solstice day, when at exactly 5 o’clock in the afternoon, the sun glimmers through the Peak of Shattered Hope, and the whole mountain range is dyed in a mesmerizing orange.\n
      Aside from that specific moment, the mountain range is perpetually white, covered in thick, deep snow, with blizzards constantly brewing and subsiding.\n
      The sub-zero temperature renders this place mostly inaccessible for inhabiting, humans and beasts alike, but brave souls still seek thrills atop the mountain peaks, and when things go awry, it’s turn for the Trava Knight to the rescue.
    `,
    contractAddress: "0x1aEc07118Cc8ABbb85828d4340b6Aa3cd52Dd61d",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 2,
    img: level2,
    color: "#6E7C8E",
    status: "available",
  },
  veteran: {
    id: "veteran",
    name: "Veteran",
    title: "The Mystic Forest of Mythra",
    description: `Mythra, the Mystic Forest, is located only a few hundred miles away from the Holy Citadel of Middengeard, and it is home of various mythical beasts that are only thought to exist in books.\n
      At night, Mythra emits an eerie and mysterious gold shine, said to be the lingering flame of unfortunate souls captured by the forest.\n
      True to its name, venturing into Mythra is never an easy task, when not only you can be assaulted by rogue monsters at any moment, but the layout of the forest also changes constantly, rendering most maps useless.\n
      Only the most veteran of Knights are capable of navigating the forest with the assist of a special compass, and only they are capable of subduing monstrous mythical beasts - either to rescue wandering folks, or to collect ingredients for the Kingdom.
    `,
    contractAddress: "0xd52D8A80aae0E2bc92De3C7CE9Aca167b3fAb193",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 3,
    img: level3,
    color: "#C69B03",
    status: "available",
  },
  elite: {
    id: "elite",
    name: "Elite",
    title: "The Southern Empty",
    description: `Located on the southern basin of  Trava Kingdom is a vast uninhabitable landmass, usually referred to as the Southern Empty.\n
      The landmass is composed of several natural - or alien - stone pillars, with mysterious carvings of undiscovered origins. Even more strange, the pillars have veins latched onto them, and one can clearly see purple substances flowing inside these veins into the pillars, then disperses into the air in the form of a thick purple mist.\n
      The composition of the purple mist has not yet been known, since any attempt to contain these mist ended in failure. But it is believed that the mist directly affects one’s mind, as upon entering the Southern Empty, most people feel an unexplainable dread and despair, and in extreme cases, some end their lives on the spot.\n
      Thus, only the most elite and most steel-hearted Knights are capable of exploring the Southern Empty, and their efforts have recovered important artifacts from long lost past.    
    `,
    contractAddress: "",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 4,
    img: level4,
    color: "#8B28B4",
    status: "unavailable",
  },
  master: {
    id: "master",
    name: "Master",
    title: "Duparrich Bay",
    description: `Only ten years ago, Duparrich Bay was the “Jewel of the Ocean”, the most important harbor of the Trava Kingdom, where three-quarters of foreign exchange must pass through.\n
      Not only did it lie on the intercontinental trade route, it also had beautiful beaches which proved popular with local folks and foreign tourists alike.\n
      Then, on that fateful day, the Darkeye Pirates came.\n
      With manpower up to hundreds of thousands, led by the self-proclaimed Pirate King Darkbeard, they ransacked the harbor, then occupied Duparrich Bay and turned it into its lair, occasionally sending pirate ships to wreck havoc on the East Sea.\n
      Several attempts to thwart the evil have been made, but the Darkeye’s strength is monumental, not to mention The Pirate King himself, who commands powers far from that of a human.\n
      Thus, a trip into Duparrich Bay, whether for rescuing civilians or retrieving pirated goods, is not for the inexperienced Knights, and surely one must think twice before charging into the evil’s jaw.
    `,
    contractAddress: "",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 5,
    img: level5,
    color: "#1A80DE",
    status: "unavailable",
  },
  ultimate: {
    id: "ultimate",
    name: "Ultimate",
    title: "No Man’s Land, Nemoira",
    description: undefined,
    contractAddress: "",
    order: 6,
    img: level6,
    color: "#99251F",
    status: "unavailable",
  },
};

const vaultConfigMainnet = {
  rookie: {
    id: "rookie",
    name: "Rookie",
    title: "Ruins of Alzatecia",
    description: `The Ruins of Alzatecia is located far to the west of the Trava Kingdom, in the middle of the Nymeria desert. Once a prosperous city, all that is left now are some stone columns and stone statues, portraying long forgotten kings - or gods.\n
      It is still unknown why Alzatecia was destroyed, but historians have agreed that the city’s position between the rocky pillars made it invulnerable to invasions. Upon further inspection of skeletons, traces of a deadly bacteria were found, and historians concluded that the city was most probably wiped by a plague.\n
      Nevertheless, adventurers still venture to these ruins, trying to find lost artifacts to collect or to sell on the black market. But, the land is desolated and infested with desert monsters - huge sandworms, giant vultures and deadly spiders - and the duty of keeping the place safe for travel falls on the noble Trava Knights.
    `,
    contractAddress: "0x5B9050F8C56EaF91a283aEB2fbB4eC5D61Ab682B",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 1,
    img: level1,
    color: "#6F3902",
    failureRefund: 50,
    status: "available",
  },
  professional: {
    id: "professional",
    name: "Professional",
    title: "Peaks of Orange Mountain",
    description: `Situated on the Northern border of the Kingdom, Orange Mountain range got its name from the spectacular sight on the Summer Solstice day, when at exactly 5 o’clock in the afternoon, the sun glimmers through the Peak of Shattered Hope, and the whole mountain range is dyed in a mesmerizing orange.\n
      Aside from that specific moment, the mountain range is perpetually white, covered in thick, deep snow, with blizzards constantly brewing and subsiding.\n
      The sub-zero temperature renders this place mostly inaccessible for inhabiting, humans and beasts alike, but brave souls still seek thrills atop the mountain peaks, and when things go awry, it’s turn for the Trava Knight to the rescue.
    `,
    contractAddress: "0x5B6f3CAD58626D409494A8800f60ec1a10C8e929",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 2,
    img: level2,
    color: "#6E7C8E",
    failureRefund: 150,
    status: "available",
  },
  veteran: {
    id: "veteran",
    name: "Veteran",
    title: "The Mystic Forest of Mythra",
    description: `Mythra, the Mystic Forest, is located only a few hundred miles away from the Holy Citadel of Middengeard, and it is home of various mythical beasts that are only thought to exist in books.\n
      At night, Mythra emits an eerie and mysterious gold shine, said to be the lingering flame of unfortunate souls captured by the forest.\n
      True to its name, venturing into Mythra is never an easy task, when not only you can be assaulted by rogue monsters at any moment, but the layout of the forest also changes constantly, rendering most maps useless.\n
      Only the most veteran of Knights are capable of navigating the forest with the assist of a special compass, and only they are capable of subduing monstrous mythical beasts - either to rescue wandering folks, or to collect ingredients for the Kingdom.
    `,
    contractAddress: "0x2393C076fE12Ceeab778D07EAa8922c2D35616b5",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 3,
    img: level3,
    color: "#C69B03",
    failureRefund: 300,
    status: "available",
  },
  elite: {
    id: "elite",
    name: "Elite",
    title: "The Southern Empty",
    description: `Located on the southern basin of  Trava Kingdom is a vast uninhabitable landmass, usually referred to as the Southern Empty.\n
      The landmass is composed of several natural - or alien - stone pillars, with mysterious carvings of undiscovered origins. Even more strange, the pillars have veins latched onto them, and one can clearly see purple substances flowing inside these veins into the pillars, then disperses into the air in the form of a thick purple mist.\n
      The composition of the purple mist has not yet been known, since any attempt to contain these mist ended in failure. But it is believed that the mist directly affects one’s mind, as upon entering the Southern Empty, most people feel an unexplainable dread and despair, and in extreme cases, some end their lives on the spot.\n
      Thus, only the most elite and most steel-hearted Knights are capable of exploring the Southern Empty, and their efforts have recovered important artifacts from long lost past.
    `,
    contractAddress: "0xa2af0B110F990D7A6bcBf46740c12c20960968BD",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 4,
    img: level4,
    color: "#8B28B4",
    failureRefund: 800,
    status: "available",
  },
  master: {
    id: "master",
    name: "Master",
    title: "Duparrich Bay",
    description: `Only ten years ago, Duparrich Bay was the “Jewel of the Ocean”, the most important harbor of the Trava Kingdom, where three-quarters of foreign exchange must pass through.\n
      Not only did it lie on the intercontinental trade route, it also had beautiful beaches which proved popular with local folks and foreign tourists alike.\n
      Then, on that fateful day, the Darkeye Pirates came.\n
      With manpower up to hundreds of thousands, led by the self-proclaimed Pirate King Darkbeard, they ransacked the harbor, then occupied Duparrich Bay and turned it into its lair, occasionally sending pirate ships to wreck havoc on the East Sea.\n
      Several attempts to thwart the evil have been made, but the Darkeye’s strength is monumental, not to mention The Pirate King himself, who commands powers far from that of a human.\n
      Thus, a trip into Duparrich Bay, whether for rescuing civilians or retrieving pirated goods, is not for the inexperienced Knights, and surely one must think twice before charging into the evil’s jaw.
    `,
    contractAddress: "0x4C973D5554b9451aC7e5242fA25eb3E2be3f8Bb7",
    acceptableRarities: [1, 2, 3, 4, 5],
    order: 5,
    img: level5,
    color: "#1A80DE",
    failureRefund: 6500,
    status: "available",
  },
  ultimate: {
    id: "ultimate",
    name: "Ultimate",
    title: "No Man’s Land, Nemoira",
    description: undefined,
    contractAddress: "",
    order: 6,
    img: level6,
    color: "#99251F",
    status: "unavailable",
  },
};

const vaultsConfig = environment === "testnet" ? vaultConfigTestnet : vaultConfigMainnet;

export default vaultsConfig;
